module.exports = __webpack_public_path__ + "6a012c00be38dbfa09037805d797217a.png";